export const CONTROLS_URL = 'controls';
export const SETTINGS_URL = 'settings';
export const DATA_URL = 'data';
export const GO_URL = 'go';
export const DICTIONARIES_URL = 'dictionaries';
export const IMPORT_URL = 'import';
export const ID_PARAM = 'id';
export const FAILURE_ID_PARAM = 'failureId';
export const PARENT_PARAM = 'parent';
export const ORDERS_URL = 'orders';
export const NEW_ORDER_URL = ORDERS_URL + '/new';
export const ORDER_DETAILS_URL = ORDERS_URL + '/details';

export const MAP_URL = 'map';
export const REPORTS_URL = 'reports';

export const TASKS_URL = 'tasks';
export const GO_TASK_URL = `${GO_URL}/${TASKS_URL}`
export const DEFECTS_URL = 'defects';
export const UNAUTHORIZED_URL = 'unauthorized';
export const TOWERS_URL = 'towers';
export const SPANS_URL = 'spans';
export const LINES_URL = 'lines';
export const FORMS_URL = 'forms'
export const PREVIEW_URL = 'preview'
export const PDF_FILES_URL = 'pdf-files';
export const IMPORT_PDF_URL = 'import-pdf'

